<template>
  <mia-form @submit="save">
    <mia-form-section
      title="Carana Rechnungsempfänger"
      description="An die hier hinterlegten Daten erhalten Sie Ihre Carana Rechnung."
    >
      <mia-form-section-grid>
        <!-- Accounting Enabled -->
        <div
          v-if="isRoot"
          class="col-span-2"
        >
          <mia-feature-toggle
            v-model="isAccountingEnabled"
            label="Abrechnung aktiv"
            label-position="top"
            :labels="{
              unchecked: 'Nein',
              checked: 'Ja',
            }"
            @input="onAccountingEnabledInput"
          />

          <div class="relative">
            <mia-input-error :errors="getErrors('item_accounting_enabled')" />
          </div>
        </div>

        <!-- Accounting Receiver Email -->
        <div>
          <mia-feature-input
            v-model="form.item_accounting_receiver_email"
            label="E-Mail Adresse"
            type="email"
            required
            :errors="getErrors('item_accounting_receiver_email')"
            @input="clearErrors('item_accounting_receiver_email')"
          />
        </div>

        <!-- Accounting Receiver Name -->
        <div>
          <mia-feature-input
            v-model="form.item_accounting_receiver_name"
            label="Name"
            required
            :errors="getErrors('item_accounting_receiver_name')"
            @input="clearErrors('item_accounting_receiver_name')"
          />
        </div>
      </mia-form-section-grid>
    </mia-form-section>

    <template #actions>
      <div class="flex items-center justify-between w-full">
        <mia-section-progress
          group="settingsBasics"
          page="invoice"
          section="invoiceData"
        />

        <mia-submit-button
          :disabled="$wait.any"
          :is-loading="$wait.is('updating invoice data')"
        />
      </div>
    </template>
  </mia-form>
</template>

<script>
import { mapGetters } from 'vuex'
import { updateInvoiceData } from '@/api/settings'
import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import FeatureToggle from '@/components/cars/edit/FeatureToggle.vue'
import SectionProgress from '@/components/cars/edit/SectionProgress.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import Form from '@/components/ui/widgets/Form.vue'
import FormSection from '@/components/ui/widgets/FormSection.vue'
import FormSectionGrid from '@/components/ui/widgets/FormSectionGrid.vue'
import { handleYNBool } from '@/helpers/utils'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'

export default {
  name: 'MiaSettingsBasicsInvoiceForm',

  components: {
    'mia-feature-input': FeatureInput,
    'mia-feature-toggle': FeatureToggle,
    'mia-form': Form,
    'mia-form-section': FormSection,
    'mia-form-section-grid': FormSectionGrid,
    'mia-section-progress': SectionProgress,
    'mia-submit-button': SubmitButton
  },

  mixins: [HandlesBackendValidationErrors],

  data() {
    return {
      form: {
        item_accounting_enabled: '',
        item_accounting_receiver_email: '',
        item_accounting_receiver_name: ''
      },
      isAccountingEnabled: false
    }
  },

  computed: {
    ...mapGetters('settings', ['settings'])
  },

  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler(settings) {
        if (this.isRoot) {
          this.$set(this.form, 'item_accounting_enabled', settings.item_accounting_enabled)
          this.isAccountingEnabled = handleYNBool(settings.item_accounting_enabled)
        }

        this.$set(this.form, 'item_accounting_receiver_email', settings.item_accounting_receiver_email)
        this.$set(this.form, 'item_accounting_receiver_name', settings.item_accounting_receiver_name)
      }
    }
  },

  methods: {
    async save() {
      this.resetErrors()
      this.$wait.start('updating invoice data')

      const payload = {
        item_accounting_receiver_email: this.form.item_accounting_receiver_email,
        item_accounting_receiver_name: this.form.item_accounting_receiver_name
      }

      if (this.isRoot) {
        payload.item_accounting_enabled = this.form.item_accounting_enabled
      }

      const [error] = await updateInvoiceData(payload)

      this.$wait.end('updating invoice data')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Fehler beim Speichern der Daten.']
        })

        this.handleBackendValidationErrors(error)
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Daten erfolgreich gespeichert.']
      })

      await this.$store.dispatch('settings/loadSettings')
    },

    onAccountingEnabledInput(isEnabled) {
      this.form.item_accounting_enabled = handleYNBool(isEnabled)
    }
  }
}
</script>
